import React, { forwardRef, memo } from 'react';
import Skeleton from '@polestar/component-warehouse-react/components/skeleton/Skeleton';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import { HeadingVariantSizes } from '@polestar/component-warehouse-react/components/heading/Heading';
const HeadingSkeleton = memo(forwardRef(({ lines = 1, size = Sizes.medium }, ref) => {
    return (React.createElement(Wrapper, { ref: ref }, Array(lines)
        .fill(null)
        .map((_, index) => (React.createElement(StyledSkeleton, { key: index, lastItem: index === lines - 1, size: size })))));
}));
HeadingSkeleton.displayName = 'HeadingSkeleton';
export default HeadingSkeleton;
const Wrapper = styled.div `
  overflow: hidden;
  width: 100%;
`;
const StyledSkeleton = styled(Skeleton, shouldNotForwardProps(false, 'lastItem', 'size', 'width', 'height'))(({ lastItem, size }) => css `
    width: ${lastItem ? `${60 + Math.random() * 30}%` : '100%'};

    ${responsiveStyles({
    height: { mobile: HeadingVariantSizes[size].lineHeight },
    marginBlockEnd: { mobile: HeadingVariantSizes[size].lineHeight },
}, {
    height: (value) => `calc(${value} * .8)`, // 24px
    marginBlockEnd: (value) => `calc(${value} * .2)`, // 6px
})}
  `);
